export const KEYWORDS_TABLE_BAR_CHART_STYLES = {
  width: 300,
  height: 150,
  fontSize: 10,
  fill: "#FFFFFF",
  axisColor: "#FFFFFF",
  backgroundColor: "rgba(36, 43, 67, .9)",
};
